import { render, staticRenderFns } from "./SelectedElementsBeam.vue?vue&type=template&id=72f7f497&scoped=true&"
import script from "./SelectedElementsBeam.vue?vue&type=script&lang=js&"
export * from "./SelectedElementsBeam.vue?vue&type=script&lang=js&"
import style0 from "./SelectedElementsBeam.vue?vue&type=style&index=0&id=72f7f497&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7f497",
  null
  
)

export default component.exports